import { absoluteAPI } from "./constants"

/**
 * This is the base API endpoint for exports.
 */
const API = "/export"

/**
 * Get the URL for exporting all notes/posts
 * The blog context is determined from authentication
 * @returns The URL path for the export API endpoint
 */
export const EXPORT_NOTES_URL = `${API}/notes`

/**
 * Get the URL for exporting all subscriptions
 * The blog context is determined from authentication
 * @returns The URL path for the export API endpoint
 */
export const EXPORT_SUBSCRIPTIONS_URL = `${API}/subscriptions`

/**
 * Downloads a file blob from a given URL
 * @param url The URL to download the file from
 * @param fileName The name to save the file as
 * @returns A Promise that resolves when the download is complete
 */
export async function downloadFileBlob(
  url: string,
  fileName: string
): Promise<void> {
  try {
    // We need to use fetch directly for blob downloads
    // The full URL includes the absoluteAPI
    const fullUrl = `${absoluteAPI}${url}`

    const response = await fetch(fullUrl, {
      credentials: "include",
    })

    if (!response.ok) {
      const errorMessage = `Error downloading ${fileName}: ${response.status} ${response.statusText}`
      console.error(errorMessage)
      throw new Error(errorMessage)
    }

    const blob = await response.blob()
    const objectURL = URL.createObjectURL(blob)

    // Create a link element and click it to trigger download
    const link = document.createElement("a")
    link.href = objectURL
    link.download = fileName
    link.click()

    // Clean up the ObjectURL to free memory after usage
    URL.revokeObjectURL(objectURL)
  } catch (error) {
    console.error("Error downloading file:", error)
    throw error
  }
}
